import React from 'react'

import twoColumnsStyles from "./TwoColumns.module.css"

export default function TwoColumns({ children, left, right, space }) {

    // console.log("left", left)
    // console.log("right", right)

    let delimeter = "[|---||---|]"    

    let delimeterFound = false
    let leftChildren = []
    let rightChildren = []

    children.forEach(child => {

        if(child.props.children === delimeter){
            delimeterFound = true
        }

        if(!delimeterFound){
            leftChildren.push(child)
        }

        if(delimeterFound && child.props.children !== delimeter){
            rightChildren.push(child)
        }

    })


    let leftStyle = left ? {maxWidth: left} : {maxWidth: 'none'}
    let rightStyle = right ? {maxWidth: right} : {maxWidth: 'none'}

    if(space){
        rightStyle.marginLeft = space
    }

    return(       
        <div className={twoColumnsStyles.container}>
            <div style={leftStyle}>
                {leftChildren}
            </div>
            <div style={rightStyle}>
                {rightChildren}
            </div>
        </div>
    )
}